import useSWR from 'swr';
import type { SteadioApiError } from '@steadioTypes/common';

export type Response = {
  contents: Array<string>;
};

export default function useFetchFollowingUuids() {
  const { data, error, mutate } = useSWR<Response, SteadioApiError>(
    `/api/v1/following/ids`,
  );
  const followingUuids = data?.contents;

  return {
    followingUuids,
    error,
    loading: !followingUuids && !error,
    mutate,
  };
}
